export const messages = {
  en: {
    userDetailRefundOrder: {
      orderNo: 'Order No',
      productName: 'Product Name',
      productSpec: 'Product Specification',
      userName: 'User Name',
      refundAmount: 'Refund Amount',
      orderStatus: 'Order Status',
      refundReason: 'Refund Reason',
      applyTime: 'Apply Time'
    }
  },
  zh: {
    userDetailRefundOrder: {
      orderNo: '订单号',
      productName: '商品名称',
      productSpec: '商品规格',
      userName: '用户名称',
      refundAmount: '退款金额',
      orderStatus: '订单状态',
      refundReason: '退款原因',
      applyTime: '申请时间'
    }
  }
}